module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1109-min.b92cc538.jpg";